import { faArrowsRotate, faCreditCard, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import UserClass from "../../components/classes/UserClass";
import LoadedRecords from "../../components/LoadedRecords";
import UserPass from "../../components/passes/UserPass";
import { FrontOfficeContext } from "./FrontOffice";
import SignOutFromClassModal from "../../components/modals/SignOutFromClassModal";
import DataForMoneyTransferModal from "../../components/modals/DataForMoneyTransferModal";

const ClassesAndPasses = () => {
    const { t } = useTranslation();
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [loadingPasses, setLoadingPasses] = useState(true);
    const { checkServerData, setAlerts, NOR } = useContext(BasicContext);
    const [classesList, setClassesList] = useState(null);
    const [passesList, setPassesList] = useState(null);
    const [displayClassesNOR, setDisplayClassesNOR] = useState(NOR);
    const [displayPassesNOR, setDisplayPassesNOR] = useState(NOR);
    const [showSignOutModal, setShowSignOutModal] = useState(false);
    const { settings } = useContext(FrontOfficeContext);
    const [showDataForMoneyTransfer, setShowDataForMoneyTransfer] = useState(false);

    const signOutFromClass = async (c) => {
        const res = await postMethod("/sign-out-from-class", { classID: c.class_id, u2cID: c.u2c_id, startTime: c.class_start_time });
        if (checkServerData(res)) {
            setAlerts([{ variant: res.data.status, message: t(`${res.data.status}.${res.data.code}`), fading: res.data.status === "success" ? 1500 : null, id: "signout" }]);
            setShowSignOutModal(false);
            setLoadingClasses(true);
            setTimeout(() => {
                getUserClassesList();
            }, 200);
        }
    };

    const getUserClassesList = async () => {
        const res = await postMethod("/get-user-classes-list");
        if (checkServerData(res)) {
            setClassesList({ activeClasses: res.data.activeClasses, historyClasses: res.data.historyClasses, showClassHistory: false });
        }
        setLoadingClasses(false);
    };

    const getUserPassesList = async () => {
        const res = await postMethod("/get-user-passes-list");

        if (checkServerData(res)) {
            setPassesList({ activePasses: res.data.activePasses, historyPasses: res.data.historyPasses, showPassHistory: false });
        }
        setLoadingPasses(false);
    };

    useEffect(() => {
        getUserClassesList();
        getUserPassesList();
        // eslint-disable-next-line
    }, []);

    return (
        <Container fluid="lg">
            <Row>
                <Col xs={12} className="px-4 mt-4 mb-3 px-lg-2 ">
                    <h1 className="h5 d-inline-block m-0 pt-2">{t("classes.assignedClasses")}</h1>

                    <Button
                        className="float-end d-inline-block me-2"
                        variant="outline-secondary"
                        onClick={() => {
                            setLoadingClasses(true);
                            setTimeout(() => {
                                getUserClassesList();
                            }, 300);
                        }}
                    >
                        <FontAwesomeIcon icon={faArrowsRotate} />
                    </Button>
                </Col>
                {loadingClasses ? (
                    <Col xs={12} className="my-4 text-center">
                        <p className="h5">
                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                        </p>
                    </Col>
                ) : (
                    <Fragment>
                        {classesList.activeClasses.length === 0 ? (
                            <Col xs={12} className="my-3 text-center">
                                <p className="opacity-50 h6 my-3">{t("notFound")}</p>
                            </Col>
                        ) : (
                            <Col xs={12} className="px-0 px-lg-2">
                                <Table size="sm" className="mb-3" id="userClassesTable">
                                    <tbody>
                                        {classesList.activeClasses.map((e, i) => (
                                            <Fragment key={i}>
                                                <UserClass c={e} i={i} onShowModal={setShowSignOutModal} />
                                            </Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        )}

                        {classesList.historyClasses.length > 0 && (
                            <>
                                {!classesList.showHistory ? (
                                    <Col xs={12} className="my-3 text-center">
                                        <Button variant="outline-secondary" onClick={() => setClassesList({ ...classesList, showHistory: true })}>
                                            {t("classes.seeHistoryOfClasses")}
                                        </Button>
                                    </Col>
                                ) : (
                                    <Col xs={12}>
                                        <Row>
                                            <p className="my-3 h5">{t("classes.historyClassesList")}</p>
                                            <LoadedRecords displayNOR={displayClassesNOR} list={classesList.historyClasses} />
                                            <Col xs={12} className="px-0">
                                                <Table size="sm" className="mb-3">
                                                    <tbody>
                                                        {classesList.historyClasses
                                                            .map((e, i) => (
                                                                <Fragment key={i}>
                                                                    <UserClass c={e} i={i} onShowModal={setShowSignOutModal} onlyDisplay showUA />
                                                                </Fragment>
                                                            ))
                                                            .slice(0, displayClassesNOR)}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                            <LoadedRecords displayNOR={displayClassesNOR} list={classesList.historyClasses} />
                                            <Col xs={12} className="text-center">
                                                {displayClassesNOR >= classesList.historyClasses.length ? (
                                                    <p className="opacity-4  mb-3">
                                                        <span className="px-3">{t("thatsAll")}</span>
                                                    </p>
                                                ) : (
                                                    <Button onClick={() => setDisplayClassesNOR(NOR + displayClassesNOR)} variant="outline-primary" className="mb-3">
                                                        {t("loadMore")}
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                )}
                            </>
                        )}
                    </Fragment>
                )}
            </Row>
            <Row>
                <Col xs={12} className="mt-4 mb-3">
                    <Row>
                        <Col xs={8} lg={6}>
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("passes.activePasses")}</h1>
                        </Col>
                        <Col xs={4} lg={6} className="text-end">
                            <Button className="d-inline-block me-2" variant="outline-secondary" onClick={() => setShowDataForMoneyTransfer(true)}>
                                <FontAwesomeIcon icon={faCreditCard} />
                                <span className="d-none d-lg-inline ms-lg-2">{t("passes.showDataForMoneyTransfer")}</span>
                            </Button>
                            <Button
                                className="d-inline-block me-2"
                                variant="outline-secondary"
                                onClick={() => {
                                    setLoadingPasses(true);
                                    setTimeout(() => {
                                        getUserPassesList();
                                    }, 300);
                                }}
                            >
                                <FontAwesomeIcon icon={faArrowsRotate} />
                            </Button>
                        </Col>
                    </Row>
                </Col>

                {loadingPasses ? (
                    <Col xs={12} className="my-4 text-center">
                        <p className="h5">
                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                        </p>
                    </Col>
                ) : (
                    <Fragment>
                        {passesList.activePasses.length === 0 ? (
                            <Col xs={12} className="text-center">
                                <p className="opacity-50 h6 my-3">{t("notFound")}</p>
                            </Col>
                        ) : (
                            <Col xs={12} className="px-0 px-lg-2">
                                <Table size="sm" className="mb-3">
                                    <tbody>
                                        {passesList.activePasses.map((e, i) => (
                                            <Fragment key={i}>
                                                <UserPass pass={e} />
                                            </Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        )}

                        {passesList.historyPasses.length > 0 && (
                            <>
                                {!passesList.showHistory ? (
                                    <Col xs={12} className="my-3 text-center">
                                        <Button variant="outline-secondary" onClick={() => setPassesList({ ...passesList, showHistory: true })}>
                                            {t("passes.seeHistoryOfPasses")}
                                        </Button>
                                    </Col>
                                ) : (
                                    <Fragment>
                                        <p className="my-3 h5">{t("passes.passesHistory")}</p>
                                        <LoadedRecords displayNOR={displayPassesNOR} list={passesList.historyPasses} />
                                        <Col xs={12} className="px-0 px-lg-2">
                                            <Table size="sm" className="mb-3">
                                                <tbody>
                                                    {passesList.historyPasses
                                                        .map((e, i) => (
                                                            <Fragment key={i}>
                                                                <UserPass pass={e} />
                                                            </Fragment>
                                                        ))
                                                        .slice(0, displayPassesNOR)}
                                                </tbody>
                                            </Table>
                                        </Col>
                                        <LoadedRecords displayNOR={displayPassesNOR} list={passesList.historyPasses} />
                                        <Col xs={12} className="text-center">
                                            {displayPassesNOR >= passesList.historyPasses.length ? (
                                                <p className="opacity-4  mb-3">
                                                    <span className="px-3">{t("thatsAll")}</span>
                                                </p>
                                            ) : (
                                                <Button onClick={() => setDisplayPassesNOR(NOR + displayPassesNOR)} variant="outline-primary" className="mb-3">
                                                    {t("loadMore")}
                                                </Button>
                                            )}
                                        </Col>
                                    </Fragment>
                                )}
                            </>
                        )}
                    </Fragment>
                )}
            </Row>

            {showSignOutModal && (
                <SignOutFromClassModal
                    onClose={() => setShowSignOutModal(false)}
                    onProceed={() => {
                        setAlerts([{ variant: "info", message: t("info.signingOutFromClass") }]);
                        setTimeout(() => {
                            signOutFromClass(showSignOutModal.c);
                        }, 150);
                    }}
                    settings={settings}
                    c={showSignOutModal}
                />
            )}

            {showDataForMoneyTransfer && <DataForMoneyTransferModal onClose={() => setShowDataForMoneyTransfer(false)} />}
        </Container>
    );
};

export default ClassesAndPasses;
